"use strict";
/**
 * @author Igor Loboda
 */
import angular from "angular";
import AppealsController from "./controller/appeals";
import AppealsFilterDirective from "./directive/appealsFilter";
import AppealsRestService from "../../rest/service/appeals";
import AppealsEditController from "./controller/edit";

export default angular
  .module("investmentProject.appeals", [])
  .controller("AppealsController", AppealsController)
  .controller("AppealsEditController", AppealsEditController)
  .directive("appealsFilter", AppealsFilterDirective)
  .service("FilterService", function () {
    this.searchData = {
      search: "",
    };
    this.filterData = {
      type: "place",
      municipalities: [],
    };
  })
  .service("AppealsRestService", AppealsRestService).name;
